import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export interface INoteExportRequest {
	startDate?: string;
	endDate?: string;
	currentUserOnly?: boolean;
	contactIds?: string[];
	companyIds?: string[];
	ownedByUserIds?: string[];
	includeEmails?: boolean;
}

export const useExportNotesMutation = ({
	onError,
	onSuccess,
	impersonationContext,
}: {
	onSuccess?: (data: Api.ISystemJob) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
	impersonationContext?: Api.IImpersonationContext;
} = {}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ exportRequest }: { exportRequest?: INoteExportRequest } = {}) => {
			return userSession.webServiceHelper.callAsync<Api.ISystemJob>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: 'note/export',
					impersonationContext,
				}),
				'POST',
				exportRequest ?? {}
			);
		},
		onError,
		onSuccess,
	});
};
